<template>
  <button
    :disabled="isDisabled"
    :class="classNames"
    @click="_handleClick"
  >
    <span v-if="!isLoading">{{ $t(buttonLabel) }}</span>
    <div
      v-else
      class="redirect-spinner-wrapper"
    >
      <spinner-button />
    </div>
  </button>
</template>

<script>
import SpinnerButton from "@/components/svg/SpinnerButton";

export default {
  components: {
    SpinnerButton
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    buttonLabel: {
      type: String,
      default: "pay"
    },
    /**
     * btn--lrg
     * btn--green-teal
     */
    classNamesProp: {
      type: Array,
      default: () => ["btn"]
    }
  },
  computed: {
    classNames() {
      return this.classNamesProp;
    }
  },
  methods: {
    _handleClick() {
      this.$emit("click");
    }
  }
};
</script>

<style>
</style>
